import { ISumResultScore } from '@/shared/api-client/models/sum-result-score';
import GenderIconComponent from '@/shared/components/gender-icon-component/gender-icon-component.vue';
import { Component } from 'vue-property-decorator';
import BaseElectionResultListComponent from '../base-result-list-component';

@Component({
    components: {
        GenderIconComponent
    }
})
export default class SumElectionResultListComponent extends BaseElectionResultListComponent<ISumResultScore> {

    public getVoteSumSuffix(voteSum: number | undefined): string {

        if (voteSum === undefined) {
            return '';
        }

        if (voteSum <= 1) {
            return this.translations['sum_result_count_single_suffix'];
        } else {
            return this.translations['sum_result_count_suffix'];
        }
    }
}
